// components/Layout.jsx
import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

const Layout = ({ children }) => {
  return (
    <div
      className="full-screen-div"
      style={{
        backgroundImage: `url('/assets/desktop.png')`,
        padding: '0 20px',
        paddingTop: '80px',
        paddingBottom: '45px',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <Navbar />
      {children}
      <Footer />
    </div>
  );
};

export default Layout;
